import React from 'react';
import BaseSelect from './_internal/BaseSelect';

const Select = (props) => <BaseSelect {...props} />;

export default React.memo(Select);
